import _ from "lodash";
import { createSelector } from "reselect";
import { Venue } from "sweet-global";
import { RootState } from "sweet-web/redux";
import { getBooking } from "./booking";
import { chat, chatVenues } from "./chat";
import { userType } from "./user";

const s = (state: RootState) => state.venue;

export const isUpdatingVenue = (state: RootState) => s(state).isUpdatingVenue;

export const isGettingMyVenues = (state: RootState) =>
  s(state).isGettingMyVenues;

export const isCreatingVenue = (state: RootState) => s(state).isCreatingVenue;

export const linkStripe = (state: RootState) => s(state).linkStripe;

export const venueUsers = (state: RootState) => s(state).venueUsers;

export const getVenue = (venueId: string) =>
  createSelector(
    venues,
    myVenues,
    chatVenues,
    (venuesValue, myVenuesValue, chatVenuesValue) => {
      let venue = null;
      if (myVenuesValue && _.get(myVenuesValue, venueId)) {
        venue = _.get(myVenuesValue, venueId);
      } else if (venuesValue && _.get(venuesValue, venueId)) {
        venue = _.get(venuesValue, venueId);
      } else if (chatVenuesValue && _.get(chatVenuesValue, venueId)) {
        venue = _.get(chatVenuesValue, venueId);
      }

      return venue as Venue | null;
    }
  );

export const getVenueUsers = (venueId: string) =>
  createSelector(venueUsers, venueUsersValue =>
    _.get(venueUsersValue, venueId)
  );

export const getVenueByChat = (chatId: string) =>
  createSelector(chat(chatId), chatValue => getVenue(chatValue.venue));

export const getVenueByBooking = (bookingId: string) =>
  createSelector(getBooking(bookingId), bookingValue =>
    getVenue(bookingValue.venue)
  );

export const venues = (state: RootState) => s(state).venues;

export const myVenues = (state: RootState) => s(state).myVenues;

export const venueActivated = (venueId: string) =>
  createSelector(getVenue(venueId), venueValue =>
    venueValue ? Boolean(venueValue.activationTime) : null
  );

export const venueName = (venueId: string) =>
  createSelector(getVenue(venueId), venueValue =>
    venueValue ? venueValue.name : null
  );

export const venueEventTypes = (venueId: string) =>
  createSelector(getVenue(venueId), venueValue =>
    venueValue ? venueValue.eventTypes : null
  );
